import { StyleRules, Theme } from '@material-ui/core';

export default (theme: Theme): StyleRules => ({
  bottom: {
    height: '100%',
    paddingBottom: '10%',
  },
  buttonContainer: {
    alignContent: 'flex-end',
    alignSelf: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '30px',
  },
  content: {
    height: '100%',
    minHeight: '65vh',
  },
  formControl: {
    margin: '45px 0',
    width: '100%',
  },
  fullWidth: {
    width: '100%',
  },
  header: {
    marginBottom: '10%',
    top: 0,
  },
  left: {
    [theme.breakpoints.up('sm')]: {
      minWidth: '600px',
    },
    position: 'relative',
    zIndex: 1,
  },
  link: {
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:visited': {
      color: '#1C8ED9',
    },
    color: '#1C8ED9',
    textDecoration: 'none',
  },
  serviceRules: {
    color: '#8083a0',
    padding: '0 5vw',
    paddingTop: '20px',
    position: 'absolute',
    textAlign: 'center',
    width: '100%',
  },
  serviceRulesWrapper: {
    position: 'relative',
  },
  stepDescription: {
    color: 'white',
    marginTop: '10px',
  },
  stepTitle: {
    color: 'white',
    fontWeight: 600,
  },
  submitButton: {
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: '#2D2E41',
      color: '#8083a0',
    },
    backgroundColor: '#2E83D9',
    borderRadius: '12px',
    color: 'white',
    fontSize: '1.2rem',
    height: '64px',
    width: '100%',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      height: '64px',
    },
    backgroundColor: 'white',
    borderRadius: 10,
    height: '64px',
    margin: '5px 0',
  },
});
